import { createI18n } from "vue-i18n";
import en from "vuetify/lib/locale/en.mjs";
import zhHans from "vuetify/lib/locale/zh-Hans.mjs";
import ko from "vuetify/lib/locale/ko.mjs";
import menu_messages from "@/i18n/locales/translations/menu_messages";
import customer_messages from "@/i18n/locales/translations/customer_messages";
import system_messages from "@/i18n/locales/translations/system_messages";
import board_messages from "@/i18n/locales/translations/board_messages";
import signin_messages from "@/i18n/locales/translations/signin_messages";
import rules_messages from "@/i18n/locales/translations/rules_messages";
import common_messages from "@/i18n/locales/translations/common_messages";
import variable_messages from "@/i18n/locales/translations/variable_messages";
import button_messages from "@/i18n/locales/translations/button_messages";
import confirm_messages from "@/i18n/locales/translations/confirm_messages";
import user_menu_messages from "@/i18n/locales/translations/user_menu_messages";
import inspection_messages from "@/i18n/locales/translations/inspection_messages";
import inventory_messages from "@/i18n/locales/translations/inventory_messages";
import receiving_messages from "@/i18n/locales/translations/receiving_messages";
import hscode_messages from "@/i18n/locales/translations/hscode_messages";
import mawb_messages from "@/i18n/locales/translations/mawb_messages";
import invoice_messages from "@/i18n/locales/translations/invoice_messages";
import shipping_messages from "@/i18n/locales/translations/shipping_messages";
import purchase_messages from "@/i18n/locales/translations/purchase_messages";

const messages = {
  en: {
    $vuetify: en,
    common: common_messages.en,
    button: button_messages.en,
  },
  ko: {
    $vuetify: ko,
    common: common_messages.ko,
    variable: variable_messages.ko,
    button: button_messages.ko,
    confirm: confirm_messages.ko,
    rules: rules_messages.ko,
    menu: menu_messages.ko,
    customer: customer_messages.ko,
    system: system_messages.ko,
    board: board_messages.ko,
    signIn: signin_messages.ko,
    userMenu: user_menu_messages.ko,
    inspection: inspection_messages.ko,
    inventory: inventory_messages.ko,
    receiving: receiving_messages.ko,
    hsCode: hscode_messages.ko,
    mawb: mawb_messages.ko,
    invoice: invoice_messages.ko,
    shipping: shipping_messages.ko,
    purchase: purchase_messages.ko,
  },
  "zh-cht": {
    $vuetify: zhHans,
    common: common_messages.zhHans,
    button: button_messages.zhHans,
  },
};

const i18n = createI18n({
  legacy: false, // Vuetify does not support the legacy mode of vue-i18n
  locale: localStorage.getItem("locale") ?? "ko",
  fallbackLocale: "en",
  // globalInjection: false,
  messages,
});

export default i18n;
